import { render, staticRenderFns } from "./Frequency.vue?vue&type=template&id=53e2ad1f&scoped=true&"
import script from "./Frequency.vue?vue&type=script&lang=js&"
export * from "./Frequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2ad1f",
  null
  
)

export default component.exports